const pad2 = (value) => String(value).padStart(2, '0');

function partsFromDateObject(value) {
  if (!(value instanceof Date) || Number.isNaN(value.getTime())) return null;
  return {
    year: value.getFullYear(),
    month: value.getMonth() + 1,
    day: value.getDate(),
    hour: value.getHours(),
    minute: value.getMinutes(),
  };
}

function partsFromString(value) {
  const raw = String(value || '').trim();
  if (!raw) return null;

  const normalized = raw.replace(/\//g, '-');
  const match = normalized.match(
    /^(\d{4})-(\d{1,2})-(\d{1,2})(?:[T\s](\d{1,2}):(\d{1,2}))?/
  );

  if (match) {
    return {
      year: Number(match[1]),
      month: Number(match[2]),
      day: Number(match[3]),
      hour: match[4] === undefined ? null : Number(match[4]),
      minute: match[5] === undefined ? null : Number(match[5]),
    };
  }

  const parsed = new Date(raw);
  return partsFromDateObject(parsed);
}

export function getDateParts(value) {
  if (value === null || value === undefined || value === '') return null;
  if (value instanceof Date) return partsFromDateObject(value);
  if (typeof value === 'number') return partsFromDateObject(new Date(value));
  return partsFromString(value);
}

export function formatDateDisplay(value, fallback = '-') {
  const parts = getDateParts(value);
  if (!parts) return fallback;
  return `${parts.year}/${pad2(parts.month)}/${pad2(parts.day)}`;
}

export function formatDateInput(value, fallback = '') {
  const parts = getDateParts(value);
  if (!parts) return fallback;
  return `${parts.year}-${pad2(parts.month)}-${pad2(parts.day)}`;
}

export function formatDateTimeDisplay(value, fallback = '-') {
  const parts = getDateParts(value);
  if (!parts) return fallback;
  const hour = parts.hour ?? 0;
  const minute = parts.minute ?? 0;
  return `${formatDateDisplay(value, fallback)} ${pad2(hour)}:${pad2(minute)}`;
}

export function formatDateTimeInput(value, fallback = '') {
  const parts = getDateParts(value);
  if (!parts) return fallback;
  const hour = parts.hour ?? 0;
  const minute = parts.minute ?? 0;
  return `${formatDateInput(value, fallback)}T${pad2(hour)}:${pad2(minute)}`;
}

export function formatMonthYearDisplay(value, fallback = '-') {
  const parts = getDateParts(value);
  if (!parts) return fallback;
  return `${parts.year}/${pad2(parts.month)}`;
}

export function todayDateInput() {
  return formatDateInput(new Date());
}

export function nowDateTimeInput() {
  return formatDateTimeInput(new Date());
}

export const dateLtrSx = {
  direction: 'ltr',
  unicodeBidi: 'embed',
  textAlign: 'inherit',
  display: 'inline-block',
};
